import { has, keys } from 'ramda'

export const serializeMarkdown = nodes => {
  if (!nodes?.map) return ''
  return nodes.map(n => serializeNode(n)).join('')
}

const isInline = node => !!node.text || ['image', 'link'].includes(node.type)

const serializeNode = (node, parentType) => {
  if (has('text', node)) return serializeLeaf(node)
  return formatNodeByType(node, parentType)
}

const formatNodeByType = (node, parentType) => {
  const innerValue = node.children.map(child => serializeNode(child, node.type)).join('')
  switch (node.type) {
    case 'image':
      return `![](${node.url})`
    case 'link':
      return `[${innerValue}](${node.url})`
    case 'list_item':
      let prefix = parentType === 'list' ? '- ' : '1. '
      return prefix + innerValue + '\n'
    case 'paragraph':
      return innerValue + '\n'
    case 'list':
    case 'numbered_list':
      return innerValue + '\n'
    default:
      return innerValue
  }
}

const serializeLeaf = leaf => {
  return keys(leaf).reduce((finalValue, key) => {
    const value = leaf[key]
    if (!finalValue) return finalValue

    if (key === 'bold' && value === true) {
      return `**${finalValue}**`
    }
    if (key === 'italic' && value === true) {
      return `*${finalValue}*`
    }
    return finalValue
  }, leaf.text)
}
